var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "url(#paint0_linear_1_2376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7999 22.3H42.2999C42.9999 22.3 43.4999 21.7 43.4999 21.1V18.6C43.4999 17.9 42.8999 17.4 42.2999 17.4H38.5999C38.5999 16 37.4999 14.9 36.0999 14.9C34.6999 14.9 33.5999 16 33.5999 17.4H29.8999C29.1999 17.4 28.6999 18 28.6999 18.6V21C28.4999 21.7 29.0999 22.3 29.7999 22.3ZM50.9999 19.8H45.9999V21C45.9999 23.1 44.2999 24.7 42.2999 24.7H29.7999C27.6999 24.7 26.0999 23 26.0999 21V19.8H21.0999C20.3999 19.8 19.8999 20.4 19.8999 21V56C19.8999 56.7 20.4999 57.2 21.0999 57.2H51.0999C51.7999 57.2 52.2999 56.6 52.2999 56V21C52.1999 20.3 51.6999 19.8 50.9999 19.8ZM37.1999 34.8C37.1999 34.1 37.7999 33.6 38.3999 33.6H39.5999V29.9C39.5999 29.2 40.1999 28.7 40.7999 28.7C41.4999 28.7 41.9999 29.3 41.9999 29.9V33.6H43.1999C43.8999 33.6 44.3999 34.2 44.3999 34.8V42.3C44.3999 43 43.7999 43.5 43.1999 43.5H41.9999V47.2C41.9999 47.9 41.3999 48.4 40.7999 48.4C40.0999 48.4 39.5999 47.8 39.5999 47.2V43.5H38.3999C37.6999 43.5 37.1999 42.9 37.1999 42.3V34.8ZM27.2999 34.8C27.2999 34.1 27.8999 33.6 28.4999 33.6H29.6999V29.9C29.6999 29.2 30.2999 28.7 30.8999 28.7C31.5999 28.7 32.0999 29.3 32.0999 29.9V33.6H33.2999C33.9999 33.6 34.4999 34.2 34.4999 34.8V42.3C34.4999 43 33.8999 43.5 33.2999 43.5H32.0999V47.2C32.0999 47.9 31.4999 48.4 30.8999 48.4C30.1999 48.4 29.6999 47.8 29.6999 47.2V43.5H28.4999C27.7999 43.5 27.2999 42.9 27.2999 42.3V34.8ZM45.9999 53.5H25.9999C25.2999 53.5 24.7999 52.9 24.7999 52.3C24.7999 51.6 25.3999 51.1 25.9999 51.1H45.9999C46.6999 51.1 47.1999 51.7 47.1999 52.3C47.1999 52.9 46.6999 53.5 45.9999 53.5ZM32.2999 36H29.7999V41H32.2999V36ZM42.1999 36H39.6999V41H42.1999V36Z",
    fill: "url(#paint1_linear_1_2376)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2376",
    x1: 36,
    y1: 72,
    x2: 36,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3FFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#F0FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2376",
    x1: 35.9999,
    y1: 14.766,
    x2: 35.9999,
    y2: 57.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CFFAC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI4);
export default __webpack_public_path__ + "static/media/i4.6f3f06ecabf99f27eff3e6d9432ea362.svg";
export { ForwardRef as ReactComponent };